import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useColorModeValue,
} from '@chakra-ui/react';
import PipelineResults from '../../dataPipelines/pipelineResults/PipelineResults';

const PipelineResultsModal = ({ isOpen, onClose }) => {
  const bgColor = useColorModeValue('white', 'navy.700');
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent bg={bgColor} maxH="90vh">
        <ModalHeader color={textColor} borderBottom="1px" borderColor="gray.200">
          תוצאות צינורות נתונים
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p="20px">
          <PipelineResults />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PipelineResultsModal;
